<app-header></app-header>
<navbar></navbar>
<app-footer></app-footer>
<router-outlet></router-outlet>
